// @ts-nocheck

import { MatchEntity } from '../states/entities/matches';
import { OutcomeEntity } from '../states/entities/outcomes';
import { type HistoryBetState, type HistoryMatchState } from '../states/history';
import { type HistoryTournamentState } from '../states/history';
import { type HistoryCategoryState } from '../states/history';
import { type StateType } from '../states/index';
import { type OutcomeStatus } from '../types/history';
import { type Selector } from '../types/selectors';

import {
  selectHistoryEntitiesBetsEntity,
  selectHistoryEntitiesCategoriesEntity,
  selectHistoryEntitiesMatchesEntity,
  selectHistoryEntitiesOutcomesEntity,
  selectHistoryEntitiesTournamentsEntity,
} from './history/historyPrimary.selector';
import { type HistoryEntitiesOutcomesEntitySelectorProps } from './history/historyPrimary.selector';

// no-memoize
export const selectHistoryBetFromOutcomeId: Selector<HistoryBetState | undefined> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const outcome = selectHistoryEntitiesOutcomesEntity(state, props);
  const { betId } = outcome ?? {};

  return selectHistoryEntitiesBetsEntity(state, { betId });
};

// no-memoize
export const selectHistoryMatchFromOutcomeId: Selector<HistoryMatchState | undefined> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const bet = selectHistoryBetFromOutcomeId(state, props);
  const { matchId } = bet ?? {};

  return selectHistoryEntitiesMatchesEntity(state, { matchId });
};

// no-memoize
export const selectHistoryMatchIsLiveFromOutcomeId: Selector<boolean> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const match = selectHistoryMatchFromOutcomeId(state, props);

  return MatchEntity.isLive(match);
};

// no-memoize
export const selectHistoryOutcomeStatusFromOutcomeId: Selector<OutcomeStatus> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const outcome = selectHistoryEntitiesOutcomesEntity(state, props);
  const isMatchLive = selectHistoryMatchIsLiveFromOutcomeId(state, props);

  return OutcomeEntity.getStatus(outcome, isMatchLive);
};

// no-memoize
export const selectHistoryTournamentFromOutcomeId: Selector<HistoryTournamentState | undefined> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const match = selectHistoryMatchFromOutcomeId(state, props);
  const { tournamentId } = match ?? {};

  return selectHistoryEntitiesTournamentsEntity(state, { tournamentId });
};

// no-memoize
export const selectHistoryCategoryFromOutcomeId: Selector<HistoryCategoryState | undefined> = (
  state: StateType,
  props: HistoryEntitiesOutcomesEntitySelectorProps = {},
) => {
  const tournament = selectHistoryTournamentFromOutcomeId(state, props);
  const { categoryId } = tournament ?? {};

  return selectHistoryEntitiesCategoriesEntity(state, { categoryId });
};

export type HistoryItemBets = {
  bets: Array<{
    isAvailable: boolean;
    oddId: number;
    betId: number;
    matchId: number;
  }>;
  isHidden: boolean;
  missingOutcomeCount: number;
};
